import { FC } from 'react';

import Link from 'next/link';

import { DateTime } from 'luxon';

import { SaleCaseItem } from '@type-def_iqfu/public/SaleCaseItem';

import { LandCurrentStatus, MonthOutputFormat, PropertyType, ResidenceCurrentStatus } from '@constants_iqfu';

import styles from './SaleCaseTable.module.scss';

type Props = {
  saleCasesData: SaleCaseItem[];
  //土地戸建町域ページでは場所表示しなくていい
  showPlace: boolean;
  //会社詳細では会社名表示しない
  showCompanyName?: boolean;
  pageLabel: string;
  readMoreButtonClicked: boolean;
  onlyPurchaseSaleCases: boolean;
};

const LandhousesSaleCaseTable: FC<Props> = ({
  saleCasesData,
  showPlace,
  showCompanyName,
  pageLabel,
  readMoreButtonClicked,
  onlyPurchaseSaleCases,
}) => {
  return (
    <div
      className={`${styles.saleCase_table_container} ${styles.landhouse_table} ${
        showCompanyName ? '' : styles.without_companyName
      }
      ${showPlace ? '' : styles.without_place}  ${onlyPurchaseSaleCases ? styles.without_price : ''}`}
    >
      <div className={`${styles.saleCase_table} ${readMoreButtonClicked ? styles.isScrollable : ''}`}>
        <div className={styles.table_head_row}>
          <div className={styles.table_cell}>成約年月</div>
          <div className={styles.table_cell}>物件種別</div>
          {showPlace && <div className={styles.table_cell}>所在地</div>}
          {!onlyPurchaseSaleCases && <div className={styles.table_cell}>成約価格</div>}
          {showCompanyName && <div className={styles.table_cell}>不動産会社</div>}
          <div className={styles.table_cell}>階数</div>
          <div className={styles.table_cell}>状態</div>
          <div className={styles.table_cell}>土地面積</div>
          <div className={styles.table_cell}>建物面積</div>
          <div className={styles.table_cell}>建築年月</div>
        </div>
        <div className={styles.table_data_container}>
          {saleCasesData &&
            saleCasesData.length > 0 &&
            saleCasesData.map((data: SaleCaseItem, i: number) => {
              return (
                <div key={i} className={styles.table_data_row}>
                  <div className={styles.table_cell}>
                    {DateTime.fromISO(data.contract_date).toFormat(MonthOutputFormat)}
                  </div>
                  <div className={styles.table_cell}>{PropertyType[data.property_type]}</div>
                  {showPlace && (
                    <div className={styles.table_cell}>
                      <Link prefetch={false} href={`/landhouses/${data.town.code}`}>
                        {`${data.prefecture.name}${data.city.name}${data.town.name}`}
                      </Link>
                    </div>
                  )}
                  {data.price && (
                    <div className={`${styles.table_cell} ${styles.table_cell_price}`}>
                      {data.price.toLocaleString()}万円
                    </div>
                  )}
                  {showCompanyName && (
                    <div className={styles.table_cell}>
                      <Link prefetch={false} href={`/companies/${data.company_id}`}>
                        {data.display_name}
                      </Link>
                    </div>
                  )}
                  <div className={styles.table_cell}>{`${data.floor ? data.floor + '階' : ''}`}</div>
                  <div className={styles.table_cell}>
                    {data.current_status && (
                      <>
                        {data.property_type === 'land'
                          ? LandCurrentStatus[data.current_status as keyof typeof LandCurrentStatus]
                          : ResidenceCurrentStatus[data.current_status as keyof typeof ResidenceCurrentStatus]}
                      </>
                    )}
                  </div>
                  <div className={styles.table_cell}>
                    <>{data.land_area && <span>{data.land_area} ㎡</span>}</>
                  </div>
                  <div className={styles.table_cell}>
                    <>{data.building_area && <span>{data.building_area} ㎡</span>}</>
                  </div>
                  <div className={styles.table_cell}>
                    {data.built_date && DateTime.fromISO(data.built_date).toFormat(MonthOutputFormat)}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default LandhousesSaleCaseTable;
